<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_iii"></a><em>ROARING THUNDER</em></h1>
<p class="image1"><img alt="Image" src="images/line.jpg"/></p>
<p class="sub-title">A Novel of the Jet Age</p>
<p class="image"><img alt="Image" src="images/jet.jpg"/></p>
<p class="author">WALTER J. BOYNE</p>
<p class="image"><img alt="Image" src="images/pubn.jpg"/></p>
<p class="editor">A TOM DOHERTY ASSOCIATES BOOK<br/>NEW YORK</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1cfcd764